/**
 * @generated SignedSource<<bdd2aa2762ac04ff6fe929ececc39d50>>
 * @relayHash 24954ddd5c61bb46d0c12ca8ce658977
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 07a0b6d0ab3fa61d2f1b700272cee29bfe3a244016f235e944d93196d101b083

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetIssueSearchGroupByInput = {
  fieldId?: string | null | undefined;
  viewId: string;
};
export type useSetSelectedGroupingMutation$variables = {
  input: JiraSetIssueSearchGroupByInput;
};
export type useSetSelectedGroupingMutation$data = {
  readonly jira_setIssueSearchGroupBy: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useSetSelectedGroupingMutation = {
  response: useSetSelectedGroupingMutation$data;
  variables: useSetSelectedGroupingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JiraSetIssueSearchGroupByPayload",
    "kind": "LinkedField",
    "name": "jira_setIssueSearchGroupBy",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSetSelectedGroupingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSetSelectedGroupingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "07a0b6d0ab3fa61d2f1b700272cee29bfe3a244016f235e944d93196d101b083",
    "metadata": {},
    "name": "useSetSelectedGroupingMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "826544f4dd8f660081396531556cffe4";

export default node;
